module.exports = __webpack_public_path__ + "img/WM_personimage.ccf06429.png";